import { TFunction } from "i18next";
import { object, string } from "yup";

export const movePageSchema = (t: TFunction) =>
  object({
    domainId: string().required(t("folder.domainRequired")),
  });
